// Shared helpers of the static technical notes: their text lives in the module translations (calculation.notes).

// an engine warning shown in a DS2 MessageBox, which draws its own warning icon: without the HTML's leading "⚠"
export const withoutWarningSign = (text: string) => text.replace(/^⚠\s*/, "");
